module.exports = {"id":"206304","name":"Luka Milivojević","rating":"77","photo":"./data/images/photos/3/206304.png","club":{"name":"Crystal Palace","logo":"./data/images/clubs/CrystalPalace.png"},"positions":["MDC","MC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/LukaMilivojevic0.json
// module id = 2632
// module chunks = 0